<template>
  <Card
    class="opaque-70"
    :slim="slim"
    :simple="simple"
    :pinned="log.timeline_pinned"
  >
    <q-item-section class="justify-between force-row no-wrap">
      <q-item-label class="q-pr-sm">
        <span class="text-caption text-bold">
          ({{ $formatSystemDate(log.timeline_date, fullDate ? luxonFormats.SHORT_WORDED_DATE_TIME : luxonFormats.TIME) }})
        </span>
        <span v-if="modelName" class="text-caption text-bold q-pr-sm">
          {{ modelName }}
        </span>
        {{ log.description }}
      </q-item-label>
      <q-item-label
        v-if="log.category"
        caption
        class="text-right flex-auto-grow"
      >
        {{ log.category }}
      </q-item-label>
    </q-item-section>
  </Card>
</template>

<script>
import Card from 'components/partials/timeline/partials/Card'
import cardMixin from 'components/partials/timeline/partials/cardMixin'

export default {
  components: {
    Card
  },
  mixins: [cardMixin],
  props: {
    log: {
      type: Object,
      required: true
    },
    advanced: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modelName () {
      return this.advanced && this.log.timeline_morph ? this.log.timeline_morph.name : null
    }
  }
}
</script>
